
export interface BerechnungState {
    wohnflaeche: string,
    selectedBaujahr: number | null,
    selectedWohnlage: number | null,
    selectedGebaeudetyp: number | null,
    selectedHaustyp: number | null,
    selectedUnvollstaendigBeheizung: number | null,
    selectedFussbodenheizung: number | null,
    selectedSanitaerbereich: Array<number>,
    localSanitaerbereich: Array<number>,
    selectedKueche: number | null,
    selectedKuechengrundausstattung: number | null,
    selectedElektrogeraete: Array<number>,
    localElektrogeraete: Array<number>,
    selectedFussboden: number | null,
    selectedModernisierterBoden: number | null,
    selectedTerrasseBalkon: number | null,
    selectedBesondereAusstattung: number | null,
    selectedModernisierteFenster: number | null,
    abweichungGesetzt: boolean,
    abweichungen: {
        wasser: string,
        rueckgebaeude: string,
        waermedaemmung: string,
        fassadeA: string,
        fassadeB: string,
        zusatz: string,
    },
    selectedBetriebskostenA: number | null,
    selectedBetriebskostenB: Array<number>
}

export default {
    namespaced: true,
    state: {
        wohnflaeche: '',
        selectedBaujahr: null,
        selectedWohnlage: null,
        selectedGebaeudetyp: null,
        selectedHaustyp: null,
        selectedUnvollstaendigBeheizung: null,
        selectedFussbodenheizung: null,
        selectedSanitaerbereich: [],
        localSanitaerbereich: [],
        selectedKueche: null,
        selectedKuechengrundausstattung: null,
        selectedElektrogeraete: [],
        localElektrogeraete: [],
        selectedFussboden: null,
        selectedModernisierterBoden: null,
        selectedTerrasseBalkon: null,
        selectedBesondereAusstattung: null,
        selectedModernisierteFenster: null,
        abweichungGesetzt: false,
        abweichungen: {
            wasser: '',
            rueckgebaeude: '',
            waermedaemmung: '',
            fassadeA: '',
            fassadeB: '',
            zusatz: '',
        },
        selectedBetriebskostenA: null,
        selectedBetriebskostenB: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17]

    } as BerechnungState,
    getters: {
    },
    mutations: {
        SET_WOHNFLAECHE(state:BerechnungState, wohnflaeche:string) {
            state.wohnflaeche = wohnflaeche
        },
        SET_SELECTED_BAUJAHR(state:BerechnungState, selectedBaujahr:number) {
            state.selectedBaujahr = selectedBaujahr
        },
        SET_SELECTED_WOHNLAGE(state:BerechnungState, selectedWohnlage:number) {
            state.selectedWohnlage = selectedWohnlage
        },
        SET_SELECTED_GEBAEUDETYP(state:BerechnungState, selectedGebaeudetyp:number) {
            state.selectedGebaeudetyp = selectedGebaeudetyp
        },
        SET_SELECTED_HAUSTYP(state:BerechnungState, selectedHaustyp:number) {
            state.selectedHaustyp = selectedHaustyp
        },
        SET_SELECTED_UNVOLLSTAENDIG_BEHEIZUNG(state:BerechnungState, selectedUnvollstaendigBeheizung:number) {
            state.selectedUnvollstaendigBeheizung = selectedUnvollstaendigBeheizung
        },
        SET_SELECTED_FUSSBODENHEIZUNG(state:BerechnungState, selectedFussbodenheizung:number) {
            state.selectedFussbodenheizung = selectedFussbodenheizung
        },
        SET_SELECTED_SANITAERBEREICH(state:BerechnungState, selectedSanitaerbereich:Array<number>) {
            state.selectedSanitaerbereich = selectedSanitaerbereich
        },
        UPDATE_LOCAL_SANITAERBEREICH(state:BerechnungState, payload: { selection:Array<number>, none:number }) {
            if(payload.selection.includes(payload.none) && !state.localSanitaerbereich.includes(payload.none)){
                state.localSanitaerbereich = [payload.none]
            }else{
                const index = payload.selection.indexOf(payload.none);
                if (index > -1) {
                    payload.selection.splice(index, 1);
                }
                //prevent duplicate entries
                state.localSanitaerbereich = Array.from(new Set(payload.selection))
            }
        },
        SET_LOCAL_SANITAERBEREICH(state:BerechnungState, localSanitaerbereich: Array<number>){
            state.localSanitaerbereich = localSanitaerbereich
        },
        SET_SELECTED_KUECHE(state:BerechnungState, selectedKueche:number) {
            state.selectedKueche = selectedKueche
        },
        SET_SELECTED_KUECHENGRUNDAUSSTATTUNG(state:BerechnungState, selectedKuechengrundausstattung:number) {
            state.selectedKuechengrundausstattung = selectedKuechengrundausstattung
        },
        SET_SELECTED_ELEKTROGERAETE(state:BerechnungState, selectedElektrogeraete:Array<number>) {
            state.selectedElektrogeraete = selectedElektrogeraete
        },
        UPDATE_LOCAL_ELEKTROGERAETE(state:BerechnungState, payload: { selection:Array<number>, none:number }) {
            if(payload.selection.includes(payload.none) && !state.localElektrogeraete.includes(payload.none)){
                state.localElektrogeraete = [payload.none]
            }else{
                const index = payload.selection.indexOf(payload.none);
                if (index > -1) {
                    payload.selection.splice(index, 1);
                }
                //prevent duplicate entries
                state.localElektrogeraete = Array.from(new Set(payload.selection))
            }
        },
        SET_LOCAL_ELEKTROGERAETE(state:BerechnungState, localElektrogeraete:Array<number>){
            state.localElektrogeraete = localElektrogeraete
        },
        SET_SELECTED_FUSSBODEN(state:BerechnungState, selectedFussboden:number) {
            state.selectedFussboden = selectedFussboden
        },
        SET_SELECTED_MODERNISIERTERBODEN(state:BerechnungState, selectedModernisierterBoden:number) {
            state.selectedModernisierterBoden = selectedModernisierterBoden
        },
        SET_SELECTED_TERRASSEBALKON(state:BerechnungState, selectedTerrasseBalkon:number) {
            state.selectedTerrasseBalkon = selectedTerrasseBalkon
        },
        SET_SELECTED_BESONDEREAUSSTATTUNG(state:BerechnungState, selectedBesondereAusstattung:number) {
            state.selectedBesondereAusstattung = selectedBesondereAusstattung
        },
        SET_SELECTED_MODERNISIERTEFENSTER(state:BerechnungState, selectedModernisierteFenster:number) {
            state.selectedModernisierteFenster = selectedModernisierteFenster
        },
        SET_ABWEICHUNGEN(state:BerechnungState, abweichungen:BerechnungState['abweichungen']) {
            state.abweichungen = abweichungen
        },
        SET_ABWEICHUNGGESETZT(state:BerechnungState, abweichungGesetzt:boolean) {
            state.abweichungGesetzt = abweichungGesetzt
        },
        SET_SELECTED_BETRIEBSKOSTENA(state:BerechnungState, betriebskostenA:number) {
            state.selectedBetriebskostenA = betriebskostenA
        },
        SET_SELECTED_BETRIEBSKOSTENB(state:BerechnungState, betriebskostenB:Array<number>) {
            state.selectedBetriebskostenB = betriebskostenB
        }
    },
    actions: {
        SELECT_BAUJAHR({ commit }: { commit: Function }, payload: { selectedBaujahr: number, selectedBaujahrError: Object }){
            commit('SET_SELECTED_BAUJAHR', payload.selectedBaujahr)
            commit('error/SET_SELECTED_BAUJAHR_ERROR', payload.selectedBaujahrError, { root: true })
        },
        SELECT_GEBAEUDETYP({ commit }: { commit: Function }, payload: { selectedGebaeudetyp: number, selectedGebaeudetypError: Object }){
            commit('SET_SELECTED_GEBAEUDETYP', payload.selectedGebaeudetyp)
            commit('error/SET_SELECTED_GEBAEUDETYP_ERROR', payload.selectedGebaeudetypError, { root: true })
        },
        SELECT_HAUSTYP({ commit }: { commit: Function }, payload: { selectedHaustyp: number, selectedHaustypError: Object }){
            commit('SET_SELECTED_HAUSTYP', payload.selectedHaustyp)
            commit('error/SET_SELECTED_HAUSTYP_ERROR', payload.selectedHaustypError, { root: true })
        },
        SELECT_SANITAERBEREICH({ commit }: { commit: Function }, payload: { selectedSanitaerbereich: Array<number>, selectedSanitaerbereichError: Array<Object> }){
             commit('SET_SELECTED_SANITAERBEREICH', payload.selectedSanitaerbereich)
             commit('error/SET_SELECTED_SANITAERBEREICH_ERROR', payload.selectedSanitaerbereichError, { root: true })
        },
        SET_SANITAERBEREICH({ commit }: { commit: Function }, selectedSanitaerbereich: Array<number>){
            commit('SET_SELECTED_SANITAERBEREICH', selectedSanitaerbereich)
            commit('SET_LOCAL_SANITAERBEREICH', selectedSanitaerbereich)
        },
        SELECT_KUECHENGRUNDAUSSTATTUNG({ commit }: { commit: Function }, payload: { selectedKuechengrundausstattung: number, selectedKuechengrundausstattungError: Object }){
            commit('SET_SELECTED_KUECHENGRUNDAUSSTATTUNG', payload.selectedKuechengrundausstattung)
            commit('error/SET_SELECTED_KUECHENGRUNDAUSSTATTUNG_ERROR', payload.selectedKuechengrundausstattungError, { root: true })
        },
        SELECT_ELEKTROGERAETE({ commit }: { commit: Function }, payload: { selectedElektrogeraete: Array<number>, selectedElektrogeraeteError: Array<Object> }){
             commit('SET_SELECTED_ELEKTROGERAETE', payload.selectedElektrogeraete)
             commit('error/SET_SELECTED_ELEKTROGERAETE_ERROR', payload.selectedElektrogeraeteError, { root: true })
        },
        SET_ELEKTROGERAETE({ commit }: { commit: Function }, selectedElektrogeraete: Array<number>){
            commit('SET_SELECTED_ELEKTROGERAETE', selectedElektrogeraete)
            commit('SET_LOCAL_ELEKTROGERAETE', selectedElektrogeraete)
        },
        SELECT_FUSSBODEN({ commit }: { commit: Function }, payload: { selectedFussboden: number, selectedFussbodenError: Object }){
             commit('SET_SELECTED_FUSSBODEN', payload.selectedFussboden)
             commit('error/SET_SELECTED_FUSSBODEN_ERROR', payload.selectedFussbodenError, { root: true })
        },
        SELECT_MODERNISIERTERBODEN({ commit }: { commit: Function }, payload: { selectedModernisierterBoden: number, selectedModernisierterBodenError: Object }){
             commit('SET_SELECTED_MODERNISIERTERBODEN', payload.selectedModernisierterBoden)
             commit('error/SET_SELECTED_MODERNISIERTERBODEN_ERROR', payload.selectedModernisierterBodenError, { root: true })
        },
        SELECT_FUSSBODENHEIZUNG({ commit }: { commit: Function }, payload: { selectedFussbodenheizung: number, selectedFussbodenheizungError: Object }){
             commit('SET_SELECTED_FUSSBODENHEIZUNG', payload.selectedFussbodenheizung)
             commit('error/SET_SELECTED_FUSSBODENHEIZUNG_ERROR', payload.selectedFussbodenheizungError, { root: true })
        },
        SELECT_MODERNISIERTEFENSTER({ commit }: { commit: Function }, payload: { selectedModernisierteFenster: number, selectedModernisierteFensterError: Object }){
             commit('SET_SELECTED_MODERNISIERTEFENSTER', payload.selectedModernisierteFenster)
             commit('error/SET_SELECTED_MODERNISIERTEFENSTER_ERROR', payload.selectedModernisierteFensterError, { root: true })
        },
        SELECT_TERRASSEBALKON({ commit }: { commit: Function }, payload: { selectedTerrasseBalkon: number, selectedTerrasseBalkonError: Object }){
             commit('SET_SELECTED_TERRASSEBALKON', payload.selectedTerrasseBalkon)
             commit('error/SET_SELECTED_TERRASSEBALKON_ERROR', payload.selectedTerrasseBalkonError, { root: true })
        },
        SELECT_ABWEICHUNGEN({ commit }: { commit: Function }, payload: { abweichungGesetzt: boolean, abweichungen: Object, selectedAbweichungenErrors: Array<Object> }){
            //TODO immer true!? siehe next() in BegruendeteAbweichungen.vue
            commit('SET_ABWEICHUNGGESETZT', payload.abweichungGesetzt)
            commit('SET_ABWEICHUNGEN', payload.abweichungen)
            commit('error/SET_SELECTED_ABWEICHUNGEN_ERROR', payload.selectedAbweichungenErrors, { root: true })
        },
        SELECT_BETRIEBSKOSTEN({ commit }: { commit: Function }, payload: { selectedBetriebskostenA: number, selectedBetriebskostenB: Array<number> }){
            commit('SET_SELECTED_BETRIEBSKOSTENA', payload.selectedBetriebskostenA)
            commit('SET_SELECTED_BETRIEBSKOSTENB', payload.selectedBetriebskostenB)
        },
        RESET_BERECHNUNG({ commit, dispatch }: { commit: Function, dispatch: Function }){
            commit('SET_WOHNFLAECHE', '')
            commit('SET_SELECTED_BAUJAHR', null)
            commit('SET_SELECTED_WOHNLAGE', null)
            commit('SET_SELECTED_GEBAEUDETYP', null)
            commit('SET_SELECTED_HAUSTYP', null)
            commit('SET_SELECTED_UNVOLLSTAENDIG_BEHEIZUNG', null)
            commit('SET_SELECTED_FUSSBODENHEIZUNG', null)
            dispatch('SET_SANITAERBEREICH', [])
            commit('SET_SELECTED_KUECHE', null)
            commit('SET_SELECTED_KUECHENGRUNDAUSSTATTUNG', null)
            dispatch('SET_ELEKTROGERAETE', [])
            commit('SET_SELECTED_FUSSBODEN', null)
            commit('SET_SELECTED_MODERNISIERTERBODEN', null)
            commit('SET_SELECTED_TERRASSEBALKON', null)
            commit('SET_SELECTED_BESONDEREAUSSTATTUNG', null)
            commit('SET_SELECTED_MODERNISIERTEFENSTER', null)
            commit('SET_ABWEICHUNGGESETZT', false)
            commit('SET_ABWEICHUNGEN', {
                    wasser: '',
                    rueckgebaeude: '',
                    waermedaemmung: '',
                    fassadeA: '',
                    fassadeB: '',
                    zusatz: '',
                })
            commit('SET_SELECTED_BETRIEBSKOSTENA', null)
            commit('SET_SELECTED_BETRIEBSKOSTENB', [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17])
        },
        SET_BERECHNUNG({ commit, dispatch }: { commit: Function, dispatch: Function }, payload: { berechnung:BerechnungState }) {
            if(payload.berechnung.wohnflaeche){
                commit('SET_WOHNFLAECHE', payload.berechnung.wohnflaeche)
            }
            commit('SET_SELECTED_BAUJAHR', payload.berechnung.selectedBaujahr)
            commit('SET_SELECTED_WOHNLAGE', payload.berechnung.selectedWohnlage)
            commit('SET_SELECTED_GEBAEUDETYP', payload.berechnung.selectedGebaeudetyp)
            commit('SET_SELECTED_HAUSTYP', payload.berechnung.selectedHaustyp)
            commit('SET_SELECTED_UNVOLLSTAENDIG_BEHEIZUNG', payload.berechnung.selectedUnvollstaendigBeheizung)
            commit('SET_SELECTED_FUSSBODENHEIZUNG', payload.berechnung.selectedFussbodenheizung)
            dispatch('SET_SANITAERBEREICH', payload.berechnung.selectedSanitaerbereich)
            commit('SET_SELECTED_KUECHE', payload.berechnung.selectedKueche)
            commit('SET_SELECTED_KUECHENGRUNDAUSSTATTUNG', payload.berechnung.selectedKuechengrundausstattung)
            dispatch('SET_ELEKTROGERAETE', payload.berechnung.selectedElektrogeraete)
            commit('SET_SELECTED_FUSSBODEN', payload.berechnung.selectedFussboden)
            commit('SET_SELECTED_MODERNISIERTERBODEN', payload.berechnung.selectedModernisierterBoden)
            commit('SET_SELECTED_TERRASSEBALKON', payload.berechnung.selectedTerrasseBalkon)
            commit('SET_SELECTED_BESONDEREAUSSTATTUNG', payload.berechnung.selectedBesondereAusstattung)
            commit('SET_SELECTED_MODERNISIERTEFENSTER', payload.berechnung.selectedModernisierteFenster)
            commit('SET_ABWEICHUNGGESETZT', payload.berechnung.abweichungGesetzt)
            commit('SET_ABWEICHUNGEN', {
                    wasser: payload.berechnung.abweichungen.wasser,
                    rueckgebaeude: payload.berechnung.abweichungen.rueckgebaeude,
                    waermedaemmung: payload.berechnung.abweichungen.waermedaemmung,
                    fassadeA: payload.berechnung.abweichungen.fassadeA,
                    fassadeB: payload.berechnung.abweichungen.fassadeB,
                    zusatz: payload.berechnung.abweichungen.zusatz,
                })
            commit('SET_SELECTED_BETRIEBSKOSTENA', payload.berechnung.selectedBetriebskostenA)
            commit('SET_SELECTED_BETRIEBSKOSTENB', payload.berechnung.selectedBetriebskostenB)
        }
    }
}